import AxiosWrapper from '~/assets/javascript/AxiosWrapper';
import { getField, updateField } from 'vuex-map-fields';
import { translate } from '~/assets/javascript/localization/Localization';

const getBase = `/data_api/questionnaire/result`

AxiosWrapper.init();

const getDefaultState = () => ({
  device_identifier: null,
  pn: null,
  questionnaire_id: null,
  permissions: {},
  available_answers: [],
  audit_name: null,
  audited_by: null,
  inspected_at: null,
  total_severity: null,
  total_score: null,
  total_audit_time: null,
  no_data: false
})

export const state = getDefaultState

export const mutations = {
  updateField,
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
  setState(state, device_identifier) {
    const params = AxiosWrapper.getSearchParams();
    state.device_identifier = device_identifier;
    state.pn = params.pn;
    state.questionnaire_id = params.questionnaireId;
  },
  initDataFromGet(state, getRequestData) {
    var presenter = getRequestData.presenter;

    if (!presenter || Object.keys(presenter).length === 0) {
      state.no_data = true;
      return;
    }

    state.no_data = false;
    state.audit_name = presenter.title
    state.audited_by = presenter.user.user.full_name;
    state.inspected_at = `${translate('inspected_at_with_date', { date: presenter.inspected_at })}`
    state.available_answers = getRequestData.answers;

    state.total_severity = `${translate('total_severity')}: ${presenter.total_severity}`
    state.total_score = `${translate('total_score')}: ${presenter.total_score}`
    state.total_audit_time = `${translate('total_audit_time')} (${translate('hour_minute_second')}): ${presenter.length_of_time_for_audit}`

  },
}

export const getters = {
  getField
}

export const actions = {
  async init({ commit, state }, device_identifier) {
    commit('resetState')
    commit('setState', device_identifier)

    const url = `${getBase}/${state.device_identifier}`

    AxiosWrapper.get(url, {
      params: {
        pn: state.pn,
        questionnaireId: state.questionnaire_id
      }
    }).then(function (response) {
      commit('initDataFromGet', response.data);
    })
  },
}
